
<template lang="pug">
.app-container
  Auth(v-if="status === 'auth'")
  Main(v-if="status === 'main'")
  Maintenance(v-if="status === 'maintenance'")
</template>

<script>
import {mapActions} from 'vuex'

import {mapAuto} from 'helpers/vuex-bind'

import 'App.sass'
import Auth from 'views/Auth'
import Main from 'views/Main'
import Maintenance from 'views/Maintenance'

export default {
  components: {Auth, Main, Maintenance},

  computed: {
    ...mapAuto(['status']),
  },

  async mounted() {
    try {
      await this.fetchConfig()
    }
    catch(e) {this.$handler(e)}
  },

  methods: {
    ...mapActions(['fetchConfig']),
  },
}
</script>
